import { ApiClient } from "@dpdgroupuk/cc-chat-fe";
import { CHAT_CONFIG } from "../constants/config";

export const chatApisClient = new ApiClient(CHAT_CONFIG);
